
import TitleBox from '@/components/CSS/TitleBox'
import TitleBox2 from '@/components/CSS/TitleBox2'
import pzGoodsInfo from '@/components/Bargain/pz-goods-info'
import BargainSteps from '@/components/Bargain/steps'
import GoodsListPage from '@/components/GoodsListPage'
import commonButton from '@/components/Bargain/buyer/commonButton'
const TimeCountdown = () => import('@/components/TimeCountdown')
import SellerEmpty from '@/components/Bargain/seller/Empty'
import { mapGetters } from 'vuex'
import { fixTime } from '@/utils'
export default {
	components: {
		commonButton,
		TitleBox,
		TitleBox2,
		pzGoodsInfo,
		GoodsListPage,
		BargainSteps,
		SellerEmpty,
		TimeCountdown
	},
	computed: {
		...mapGetters({
			severTime: 'severTime'
		}),
		/**
		 * 未支付并且买家已同意显示支付倒计时
		 */
		showPayCountdown() {
			return this.item.bargainOrderPayStatus === 'NOT_PAID' && this.item.bargainOrderType == 2 && this.item.payEndTime
		},
		/**
		 * 请联系客服继续交易文案
		 */
		showContactServiceText() {
			return this.item.status === 'SUCCESS' && this.item.bargainOrderPayStatus === 'PAID'
		},
		/**
		 * 商品置灰
		 * 已下架、已出售
		 */
		goodsDisabled() {
			return ['ITEM_REMOVED', 'ITEM_SOLD'].includes(this.item.substatus)
		}
	},
	data() {
		return {
			payEndTime: 0, // 待支付剩余时间
			item: {},
			/**
			 * 砍价历史
			 */
			loading: false,
			historyLists: [],
			pageInfo: {
				page: 1,
				pageSize: 5,
				total: 0
			}
		}
	},
	methods: {
		/**
		 * 获取服务器时间
		 */
		async getServerTime() {
			await this.$store.dispatch('GetSeverTime')
			this.payEndTime = (Math.round(new Date(fixTime(this.item.payEndTime)).getTime()) - (new Date().getTime() + this.severTime)) / 1000
		},
		/**
		 * 获取砍价历史
		 */
		async getBargainBuyerDetailHistory() {
			try {
				this.loading = true
				const par = {
					action: {
						goodsNo: this.item.goodsNo
					},
					page: this.pageInfo.page,
					pageSize: this.pageInfo.pageSize
				}
				const res = await this.$api.bargainBuyerDetailHistory(par)
				if (!res.success) {
					this.loading = false
					this.$message.error(res.info)
					return
				}
				this.loading = false
				this.historyLists = res.data.records
				this.pageInfo.total = Number(res.data.total)
			} catch (err) {
				this.loading = false
			}
		},
		handleCurrentChange(page) {
			this.pageInfo.page = page
		},
		handleSizeChange(pageSize) {
			this.pageInfo.page = 1
			this.pageInfo.pageSize = pageSize
		},
		/**
		 * 砍价详情
		 */
		async getBargainBuyerDetail() {
			try {
				const par = {
					action: {
						bargainOrderNo: this.$route.query.bargainOrderNo
					}
				}
				const res = await this.$api.bargainBuyerDetail(par)
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.item = res.data
			} catch (err) {}
		},
		/**
		 * 获取砍价详情和砍价历史
		 */
		async getData() {
			await this.getBargainBuyerDetail()
			await this.getBargainBuyerDetailHistory()
		},
		/**
		 * 按钮操作之后/倒计时结束重新获取数据
		 */
		onReload() {
			this.getData()
		}
	},
	async created() {
		await this.getData()
		if (this.showPayCountdown) {
			await this.getServerTime()
		}
	}
}
